import { render, staticRenderFns } from "./security-questions-verification.vue?vue&type=template&id=0eb75902&"
import script from "./security-questions-verification.vue?vue&type=script&lang=js&"
export * from "./security-questions-verification.vue?vue&type=script&lang=js&"
import style0 from "./security-questions-verification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports